import Service from "../../AuthService";
const Products = {
    getProduct(page) {
        return Service.get("/product?page="+page);
    },
    getProductAll(){
      return  Service.get("/product_all");
    },
    showProduct(id) {
        return Service.get("/product/" + id);
    },
    updateProduct(id, data) {
        return Service.put("/product/" + id, data);
    },
    createProduct(data) {
        return Service.post("/product", data);
    },
    deleteProduct(id) {
        return Service.delete("/product/" + id);
    },
    searchProduct(page,code, type) {
        return Service.post("/search-product?page="+page+"&code=" + code + "&type=" + type);
    },
    getPackProduct(){
        return Service.get('/pack-product');
    },
    updatePriceProduct(data){
        return Service.get(`/update/update_product_price?product_type_id=${data.product_type_id}`+
            `&add_price_foam=${data.add_price_foam}&add_price_other=${data.add_price_other}`+
            `&reduce_price_foam=${data.reduce_price_foam}&reduce_price_other=${data.reduce_price_other}`
        )
    },
    updateCommissionProduct(data){
        return Service.post('update_commission_product',data);
    }
};
export default Products;
